import { BatchRequestModel } from "libs/models/batch-model";
import { ValidationModel } from "libs/models/validate-model";
import { BatchStore } from "store/slices/batches";
import { numberRegex } from "utils/regex";
import translate from "utils/translations";

export const validateAddBatchState = (
  state: BatchStore
): ValidationModel<BatchRequestModel> => {
  let validationModel = {} as ValidationModel<BatchRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    state.newBatchData.version === undefined ||
    state.newBatchData.version === ""
  ) {
    validationModel.version = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (
    state.newBatchData.productItemsNumber === undefined ||
    state.newBatchData.productItemsNumber.toString() === ""
  ) {
    validationModel.productItemsNumber = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (
    !numberRegex.test(state.newBatchData.productItemsNumber.toString())
  ) {
    validationModel.productItemsNumber = translate(
      "Invalid_Data_Text",
      "Amount of cards cannot contain characters"
    );
  }
  if (
    state.newBatchData.validityPeriod === undefined ||
    state.newBatchData.validityPeriod.toString() === ""
  ) {
    validationModel.validityPeriod = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (!numberRegex.test(state.newBatchData.validityPeriod.toString())) {
    validationModel.validityPeriod = translate(
      "Invalid_Data_Text",
      "Validity period cannot contain characters"
    );
  }
  return validationModel;
};
